import sortBy from 'lodash/sortBy';
import Resources from '../../../helpers/resources';
import { ENDPOINT_PATH_LIVE_MATHS } from '../../../helpers/constants';
import DateParamHelper from '../../../helpers/date-param-helper';
import errorsActions from '../../app/errors/errors-actions';
import liveMathsLevelPickerActions from '../../../components/live-maths-level-picker/live-maths-level-picker-actions';

export const LIVE_MATHS_CLASS_RETRIEVED = 'LIVE_MATHS_CLASS_RETRIEVED';

function getLiveMathsData(classroomId, selectedDateFilter) {
    return (dispatch) =>
        Resources.singleClassReport
            .get({
                reportType: ENDPOINT_PATH_LIVE_MATHS,
                ...DateParamHelper.getDateTypePath(selectedDateFilter),
                classroomId
            })
            .withParams(DateParamHelper.getDateQueryParams(selectedDateFilter))
            .send()
            .then((payload) => {
                if (payload.valid) {
                    dispatch(liveMathsLevelPickerActions.resetLevel());
                    dispatch({
                        type: LIVE_MATHS_CLASS_RETRIEVED,
                        payload: mapLiveMathsData(payload.data)
                    });
                } else {
                    dispatch(
                        errorsActions.addError(LIVE_MATHS_CLASS_RETRIEVED)
                    );
                }
            });
}

function mapLiveMathsData(data) {
    if (!data.groupLiveMathsLevelResult) {
        return null;
    }

    const mappedGroupResults = [];
    for (const level in data.groupLiveMathsLevelResult) {
        const groupData = data.groupLiveMathsLevelResult[level];

        mappedGroupResults.push({
            id: +level,
            level,
            groups: sortBy(groupData.map(mapGroup), ['id'])
        });
    }

    return {
        classroomName: data.classroomName,
        groupLiveMathsLevelResult: mappedGroupResults
    };
}

function mapGroup(group) {
    return {
        ...group,
        studentLiveMathsResults: group.studentLiveMathsResults.map(
            (student) => ({
                id: student.userProfileId,
                studentName: `${student.lastName}, ${student.firstName}`,
                totalCorrect: mapLiveMathsScore(student.totalCorrect),
                topScore: mapLiveMathsScore(student.topScore),
                accuracy: mapLiveMathsScore(student.accuracy, '%'),
                questionsPerMinute: mapLiveMathsScore(
                    student.questionsPerMinute
                )
            })
        )
    };
}

function mapLiveMathsScore(score, suffix) {
    if (score === -1) {
        return '-';
    } else if (suffix) {
        return `${score}${suffix}`;
    }
    return score;
}

export default {
    getLiveMathsData
};



// WEBPACK FOOTER //
// ./containers/live-maths/single-class/single-class-actions.js